import styled from "styled-components"

export const Wrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid var(--line);
`

export const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: var(--header-height);
`

export const Brand = styled.a`
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  img {
    width: 154px;
    height: auto;
  }
  @media (max-width: 575px) {
    img {
      width: 130px;
    }
  }
`

export const DesktopNav = styled.nav`
  display: none;
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    gap: 1.75rem;
  }
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(13, 42, 82, 0.5);
  display: ${({ $open }) => ($open ? "block" : "none")};
  @media (min-width: 992px) {
    display: none;
  }
`

export const MobileNav = styled.nav`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 70;
  width: min(85vw, 360px);
  overflow-y: auto;
  background: var(--paper);
  border-left: 1px solid var(--line);
  &[hidden] {
    display: none;
  }
  @media (min-width: 992px) {
    display: none !important;
  }
`

export const MobileInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  padding: calc(var(--header-height) + 1rem) 1.5rem 2rem;
`
